import { Spinner, SpinnerType } from '@pluxee-design-system/core';

interface TotalCountProps {
  count?: number | string;
  isLoading?: boolean;
}

export const COUNTING = '___COUNTING___';

const TotalCount = ({ count, isLoading = false }: TotalCountProps) => {
  if (isLoading || count === COUNTING) {
    return <Spinner props={{ display: 'inline-flex' }} type={SpinnerType.SQUARE} />;
  }

  return count ?? '\u2013';
};

export default TotalCount;
